/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useProcess } from "@/global-data";
import { useToast } from "@/hooks/use-toast";
import { apiServices } from "@/services/api.services";
import { auditLog } from "@/services/global.services";
import { useEffect, useState } from "react";

export const useAuditLog = ({
  // doc_id,
  company_id,
  user_id,
  domain_id,
}: any) => {
  const [list, setList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const [paginationData, setPaginationData] = useState({
    page: 1,
    perPage: 10,
    totalItem: 1,
  });

  const onPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, page: prop }));
    setProcess(true);
    await loadAuditLogs({ page: prop });
    setProcess(false);
  };
  const onPerPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, perPage: prop, page: 1 }));
    setProcess(true);
    await loadAuditLogs({ perPage: prop, page: 1 });
    setProcess(false);
  };

  useEffect(() => {
    (async () => {
      await loadAuditLogs({});
    })();
  }, []);

  const { setProcess } = useProcess();
  const { toast } = useToast();
  const loadAuditLogs = async ({
    perPage,
    page,
  }: {
    perPage?: number;
    page?: number;
  }) => {
    setProcess(true);

    const page_no = page || paginationData.page;

    console.log("domain_id", domain_id);

    const payload = {
      data: {
        filter_by: {
          domain_id: [domain_id],
          // doc_id: doc_id,
          search_text: "",
          exact_match: false,
          pagination: {
            page_no: page_no,
            no_of_recs: perPage || paginationData.perPage,
            sort_by: "cts",
            order_by: false,
          },
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const {
      data,
      error,
      message,
      // message,
      // statusCode /* error, message, statusCode */,
    } = await apiServices<any>(auditLog.get, "post", payload);
    // await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait 5 seconds before retrying

    if (data) {
      setList(data.result.metadata[auditLog.key]);
      setPaginationData((prev) => ({
        ...prev,
        totalItem: data?.result?.metadata?.total_records || 1,
      }));
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);
    setLoading(false);
    return { data, error };
  };

  return { onPerPageChange, onPageChange, list, paginationData, loading };
};
